import Raven from 'raven-js';
// recursively looks for the root error by following the cause property until it finds the lowest level error
// this is useful for chirp errors which get nested 2 levels deep
const getRootError = (error, maxDepth = 10) => {
  if (maxDepth <= 0 || !error.cause) {
    return error;
  }
  return getRootError(error.cause, maxDepth - 1);
};

// errors thrown by the chirp client when the BE returns a valid rpc error
const isChirpError = error => 'chirpErrorMessage' in error && 'errorType' in error;
const getChirpError = error => {
  const rootError = getRootError(error);
  if (isChirpError(rootError)) {
    return rootError;
  }
  return null;
};

// errors thrown by the chirp client when there is an unexpected BE internal error
const isChirpInternalError = error => 'type' in error && error.type === 'INTERNAL_ERROR';
const getChirpInternalError = error => {
  const rootError = getRootError(error);
  if (isChirpInternalError(rootError)) {
    return rootError;
  }
  return null;
};
const IGNORED_ERROR_STATUS_CODES = [0, 409, 504];

/**
 * Logs an error to Log Fetch with structured error information
 * @param error - The error object to log
 * @param customMessage - The error message by which the errors will be grouped together in Log Fetch
 * @param status - Optional HTTP status code (certain codes like 0, 409, 504 are filtered out)
 * @param additionalDetails - Additional context to include with the error
 */
export const logRavenException = ({
  error,
  customMessage,
  status,
  additionalDetails = {}
}) => {
  const chirpError = getChirpError(error);
  const chirpInternalError = getChirpInternalError(error);
  if (status && IGNORED_ERROR_STATUS_CODES.includes(status)) return;
  Raven.captureException(Error(customMessage, {
    cause: error
  }), {
    extra: Object.assign({
      status
    }, chirpError ? {
      chirpError
    } : {}, chirpInternalError ? {
      chirpInternalError
    } : {}, additionalDetails)
  });
};